<template>
  <div class="home">
    <section>
        <header>
            <img src="@/assets/img/binance.png" alt="">
        </header>
        <div class="bgItem1Img">
            <svg width="600" height="600">
                <image x="0" y="0"
                    width="100%" height="100%"
                    xlink:href="@/assets/svg/Ribbon.svg"/>
            </svg>
        </div>
        <div class="bgItem2Img">
            <svg width="500" height="500">
                <image x="0" y="0"
                    width="100%" height="100%"
                    xlink:href="@/assets/svg/ribbon2.svg"/>
            </svg>
        </div>
        <div class="npxsxemCon">
            <div class="search">
                <div class="searchInput">
                    <input type="text" @blur="animateWidth('company_name','blur')" @focus="animateWidth('company_name','focus')" :class="{'searchValCss': searchValCss}" v-model="parameterQueryHash.hash" placeholder="Search your hash">
                    <div class="searchBtn" @click="getData">
                        <img width="100%" src="@/assets/img/icon_search@2x.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="informationList">
            <div class="informationListL" v-if="searchVal !== ''">
                <div class="informationListTitle">
                    <p class="code">{{ searchVal }}</p>
                    <nav v-if="getDataPrizeWinner.status === 1 && parameterQueryHash.hash !== ''">
                        <div class="congratulations">
                            <div class="congratulationsImg">
                                <img width="100%" src="@/assets/img/WechatIMG28.jpeg" alt="">
                            </div>
                            <h3>Congratulations</h3>
                            <p>you won the prize</p>
                        </div>
                        <div class="prize">
                            <div class="prizeWinne">
                                <p>Prize/Winne</p>
                                <p>{{ getThousandNum(getDataPrizeWinner.prizeWinner) }}</p>
                            </div>
                            <div class="prizeclass">
                                <p>Class</p>
                                <p>{{ getDataPrizeWinner.level }}</p>
                            </div>
                            <div class="Combination">
                                <p>Combination</p>
                                <p>{{ getDataPrizeWinner.code }}</p>
                            </div>
                        </div>
                    </nav>
                    <div class="congratulations" v-if="getDataPrizeWinner.status === 0 && parameterQueryHash.hash !== ''">
                        <h3>Unfortunately</h3>
                        <p>You didn't win the prize,thank you for your participation.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
let dateTime = 600
let lastClickTime = 0
export default {
    data () {
        return {
            searchValCss: false,
            searchVal: '',
            isUnfortunately: false,
            isShowNav: false,
            parameterQueryHash: {
                hash: ''
            },
            getDataPrizeWinner: {
                code: null,
                level: 0,
                prizeWinner: 0,
                status: -1,
                transactionCreateTime: 0,
            }
        }
    },
    mounted () {
        // 搜索Hash
        this.getData()
    },
    methods: {
        // 搜索失去焦点 and 获取焦点
        animateWidth(name, type) {
            if (name == "company_name") {
                if (type == "blur") {
                    this.searchValCss = false
                    if (this.searchVal !== '') this.searchValCss = true
                } else {
                    this.searchValCss = true
                    return
                }
            } 
        },
        // 搜索Hash
        getData () {
            if (this.parameterQueryHash.hash !== '') {
                this.$api.getQueryHash(this.parameterQueryHash).then((data) => {
                    console.log(data)
                    this.getDataPrizeWinner = data
                    this.searchVal = this.parameterQueryHash.hash
                })
            }
        },
        // 转千位分号
        getThousandNum (num) {
            return num.toString().replace(/\d+/, function (n) {
                return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                    return $1 + ','
                })
            })
        },
    },
    created () {
        // 获取路由传参hash值
        this.parameterQueryHash.hash = this.$route.params.searchVal !== undefined ?  this.$route.params.searchVal : ''
    }
}
</script>

<style lang="scss" scoped>
.home {
    height: 100%;
    section:nth-child(1) {
        position: relative;
        background: linear-gradient(to left, #362020, #0E0A0A);
        padding-bottom: 72px;
        overflow: hidden;
                .search {
            position: relative;
            padding-top: 30px;
            .searchInput {
                input {
                    width: calc(100% - 76px);
                    border: 0px;
                    padding: 0 12px;
                    padding-right: 64px;
                    line-height: 22px;
                    height: 41px;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #424242;
                    background: rgba(255, 255, 255, 0.85);
                    transition: background .3s linear;
                }
                .searchValCss {
                    color: #111111;
                    background: rgba(255, 255, 255, 1);
                    transition: background .5s linear;
                }
                ::-webkit-input-placeholder { /* WebKit browsers */
                    color: #424242;
                    font-size: 14px;
                }

                ::-moz-placeholder { /* Mozilla Firefox 19+ */
                    color: #424242;
                    font-size: 14px;
                }

                :-ms-input-placeholder { /* Internet Explorer 10+ */
                    color: #424242;
                    font-size: 14px;
                }
            }
            .searchBtn {
                position: absolute;
                bottom: 0;
                right: 0;
                padding: 0px 20px;
                justify-content: center;
                display: flex;
                align-items: center;
                height: 41px;
                background-color: #FFBA28;
                border-radius: 4px;
                img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
        .bgItem1Img {
            position: absolute;
            top: 0;
            left: 60%;
            pointer-events: none;
            z-index: 0;
            opacity: .7;
        }
        .bgItem2Img {
            position: absolute;
            pointer-events: none;
            top: 0;
            left: 5%;
            z-index: 0;
            opacity: .7;
        }
        header {
            padding-left: 55.5px;
            padding-bottom: 75px;
            padding-top: 38.7px;
            img {
                width: 200px;
                height: 30px;
            }
        }
        .npxsxemCon {
            max-width: 1070px;
            margin: 0 auto;
        }
    }
    section:nth-child(2) {
        background: #FFECC5;
        padding-bottom: 26px;
        height: 100vh;
        .informationList {
            max-width: 1070px;
            margin: 0 auto;
            display: flex;
            position: relative;
            top: -55px;
            .informationListL {
                width:100%;
                background: #FFFFFF;
                border-radius: 8px;
                box-shadow: 0px 18px 28px -17px rgba(255, 121, 25, 0.2);
            }
            .informationListTitle {
                padding: 50px;
                font-size: 14px;
                color: #00042D;
                font-weight: bold;
                .prize {
                    padding-top: 36px;
                    display: flex;
                    justify-content: space-around;
                    div {
                        p {
                            &:nth-child(1) {
                                font-size: 16px;
                                color: #797979;
                                padding-bottom: 4px;
                            }
                            &:nth-child(2) {
                                font-size: 20px;
                                color: #424242;
                            }
                        }
                    }
                }
                .congratulations {
                    padding-top: 53px;
                    padding-bottom: 43px;
                    text-align: center;
                    border-bottom: 0.5px solid rgba(0, 0, 0, 0.18);
                    .congratulationsImg {
                        width: 64px;
                        height: 64px;
                        padding-bottom: 2px;
                        margin-left: auto;
                        margin-right: auto;
                    }
                    h3 {
                        font-size: 28px;
                        color: #FFC533;
                    }
                    p {
                        font-size: 16px;
                        color: #797979;
                    }
                }
                .code {
                    word-break: break-word;
                    overflow: hidden;
                    font-size: 24px;
                    color: #424242;
                    letter-spacing: -0px;
                    padding: 8px 52px;
                    border: 1px dashed #FFBA28;
                }
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    .npxsxemCon, .informationList{
        width: 90%;
    }
}

@media screen and (max-width: 750px) {
    .home {
        section:nth-child(1) {
            header {
                text-align: center;
                padding-left: 0px;
                padding-bottom: 45px;
                padding-top: 20px;
                img {
                    width: 150px;
                    height: 22.5px;
                }
            }
            .bgItem1Img {
                left: 15%;
                svg {
                    width: 400px;
                    height: 400px;
                }
            }
            .bgItem2Img {
                left: 0;
                svg {
                    width: 200px;
                    height: 200px;
                }
            }
        }
        section:nth-child(2) {
            .informationList {
                display: block;
                .informationListTitle {
                    font-size: 12px;
                    padding-left: 16px;
                    padding-right: 16px;
                    padding-top: 24px;
                    .code {
                        font-size: 18px;
                        padding: 14px 19px;
                    }
                    .congratulations {
                        h3 {
                            font-size: 24px;
                        }
                        p {
                            font-size: 14px;
                        }
                    }
                    .prize {
                        div {
                            p {
                                &:nth-child(1) {
                                font-size: 14px;
                                }
                                &:nth-child(2) {
                                    font-size: 16px;
                                }
                            }
                        }
                    }
                }
                .informationListL, .informationListR {
                    width: 100%;
                }
                .informationListL {
                    ul {
                        padding-left: 16px;
                        padding-right: 16px;
                        li span{
                            width: 25%;
                            padding-left: 5px;
                        }
                    }
                }
            }
        }
    }
}
</style>
